import { render, staticRenderFns } from "./SecondStepV1.vue?vue&type=template&id=5840618e&"
import script from "./SecondStepV1.vue?vue&type=script&lang=js&"
export * from "./SecondStepV1.vue?vue&type=script&lang=js&"
import style0 from "./SecondStepV1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports